import { css } from "emotion";
import ColorServices from "../../services/ColorServices";

const button = css({
  border: "none",
  width: 402,
  display: "block",
  height: 40,
  borderRadius: 4,
  backgroundColor: ColorServices.getColor("purple"),
  textAlign: "center",
  color: "white",
  fontWeight: 500,
  fontSize: 16,
  paddingTop: 4,
  cursor: "pointer",
  margin: "0 auto",
  "&:hover": {
    backgroundColor: ColorServices.getColor("purpleMid")
  },
  "@media(max-width: 600px)": {
    width: "100%",
    height: 36,
    fontSize: 14
  }
});

const SubmitButton = () => {
  return (
    <button
      type="submit"
      className={button}
      data-cy="submitButton"
      aria-label="Submit Button"
    >
      Submit
    </button>
  );
};

export default SubmitButton;
